import * as CONSTANTS from '../constants';

type Props = {
  updated: boolean;
  showBlock: boolean;
  selected?: boolean;
};

export const useStyle = ({ showBlock, updated, selected }: Props) => {
  const colorUpdated = updated ? CONSTANTS?.SUCCESS_COLOR : CONSTANTS?.WARN_COLOR;
  const color = showBlock ? CONSTANTS?.ERROR_COLOR : colorUpdated;
  const colorSelectedFigurant = selected ? '#FFF' : 'primary.dark';
  const colorUnavailableFigurant = CONSTANTS?.UNAVAILABLE;

  return {
    color,
    colorSelectedFigurant,
    colorUnavailableFigurant,
  };
};
